import { gql } from "@apollo/client"
import {
  NOTIFICATION_V1_FRAG,
  USER_QUERY_FRAG,
} from "./notification.fragments.gql"

export const ALL_NOTIFICATION_TEMPLATES_V1 = gql`
  query NotificationTemplateListNew(
    $query: String
    $first: Int
    $skip: Int
    $filter: NotificationTemplateInput
  ) {
    allV1NotificationTemplates(
      query: $query
      first: $first
      skip: $skip
      filter: $filter
    ) {
      ...NotificationTemplateDetailV1Frag
    }
  }
  ${NOTIFICATION_V1_FRAG}
`

export const ALL_NOTIFICATION_PROVIDERS = gql`
  query NotificationProviderList($filter: NotificationProviderInput) {
    allNotificationProviders(filter: $filter) {
      id
      name
      codename
    }
  }
`

export const ALL_NOTIFICATION_DATA_SOURCES = gql`
  query DataSourceList {
    allDataSources {
      id
      inputs
      name
      outputs
      isActive
      codename
    }
  }
`

export const NOTIFICATION_TEMPLATE_BY_ID_V1 = gql`
  query NotificationTemplateNew($id: ID!) {
    v1NotificationTemplateDetail(id: $id) {
      ...NotificationTemplateDetailV1Frag
    }
  }
  ${NOTIFICATION_V1_FRAG}
`

export const NOTIFICATION_TRIGGERS = gql`
  query NotificationTriggerList(
    $query: String
    $first: Int
    $skip: Int
    $filter: NotificationTriggerInput
  ) {
    allNotificationTriggers(
      query: $query
      first: $first
      skip: $skip
      filter: $filter
    ) {
      id
      isTriggered
      usersCount
      template {
        id
        name
      }
      provider {
        id
        kind
        name
      }
      broadcastTime
      sentBy {
        id
        fullName
      }
    }
  }
`

export const NOTIFICATION_TRIGGER_DETAIL = gql`
  query NotificationTrigger($id: ID!) {
    notificationTriggerDetail(id: $id) {
      id
      isTriggered
      provider {
        id
        kind
        name
        codename
      }
      config
      providerVariables
      dataVariables
      broadcastTime
      extraFields
      userQuery {
        ...UserQueryFrag
      }
      template {
        ...NotificationTemplateDetailV1Frag
      }
    }
  }
  ${NOTIFICATION_V1_FRAG}
  ${USER_QUERY_FRAG}
`

export const ALL_USER_QUERIES = gql`
  query allUserQueries {
    allUserQuerys {
      ...UserQueryFrag
    }
  }
  ${USER_QUERY_FRAG}
`

export const TARGET_USER_COUNT = gql`
  query EndUserCount($filter: TargetUserCountInput) {
    targetUserCount(filter: $filter) {
      userCount
    }
  }
`
